"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const auth_1 = __importDefault(require("../auth"));
const fetchClient_1 = require("../utils/misc/fetchClient");
function Test() {
    const [JWTToken, setJWTToken] = (0, react_1.useState)("");
    const [auth, setAuth] = (0, react_1.useState)(null);
    const [userInfo, setUserInfo] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        function initAuth() {
            return __awaiter(this, void 0, void 0, function* () {
                const newAuth = auth_1.default.getInstance();
                setAuth(newAuth);
            });
        }
        initAuth().then();
    }, []);
    const handleAuthenticate = () => __awaiter(this, void 0, void 0, function* () {
        if (!auth)
            return;
        yield auth.authenticate("https://jo.sooqtest.com");
    });
    const fullPageWithVerified = () => __awaiter(this, void 0, void 0, function* () {
        if (!auth)
            return;
        yield auth.authenticate("https://jo.sooqtest.com", true);
    });
    const handleGetIdentity = () => __awaiter(this, void 0, void 0, function* () {
        if (!auth)
            return;
        const identity = yield auth.getIdentity();
        setUserInfo(identity);
        return identity;
    });
    const handleGenerateToken = () => __awaiter(this, void 0, void 0, function* () {
        if (!auth)
            return;
        const token = yield auth.getToken(true);
        setJWTToken(token);
    });
    const handleGenerateTokenVerified = () => __awaiter(this, void 0, void 0, function* () {
        if (!auth)
            return;
        auth.getToken(true, true).then((token) => {
            handleGetIdentity();
            setJWTToken(token);
        });
    });
    const handleLogout = () => __awaiter(this, void 0, void 0, function* () {
        if (!auth)
            return;
        try {
            yield auth.destroy();
            window.location.reload();
            console.log("Successfully Logout");
        }
        catch (e) {
            console.error("error", e);
        }
    });
    const sendEmail = () => __awaiter(this, void 0, void 0, function* () {
        const memebr = yield handleGetIdentity();
        yield (0, fetchClient_1.fetchAtClientSide)({
            url: "slr/email",
            body: {
                email: memebr === null || memebr === void 0 ? void 0 : memebr.M_new_email,
            },
            method: "POST",
        });
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: handleAuthenticate }, { children: "Authenticate" })) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ className: "blueBtn p-16", onClick: handleGenerateToken }, { children: "Generate JWT" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { wordBreak: "break-word" } }, { children: JWTToken }))] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: handleGenerateTokenVerified }, { children: "Verified token" })) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: handleGetIdentity }, { children: "get identity" })), (0, jsx_runtime_1.jsx)("div", { children: userInfo && JSON.stringify(userInfo) })] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: fullPageWithVerified }, { children: "FullPage verified" })) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: handleLogout }, { children: "Logout" })) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => auth_1.default.getInstance().changePassword() }, { children: "Change Password" })) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => auth_1.default.getInstance().changeMobilePhone() }, { children: "Change Phone Number" })) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("h3", { children: "Verify Email" }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: sendEmail }, { children: "Send Email" })) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => __awaiter(this, void 0, void 0, function* () {
                            yield handleGenerateToken();
                            console.log("button 1");
                        }) }, { children: "Button 1" })), (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => __awaiter(this, void 0, void 0, function* () {
                            yield handleGenerateToken();
                            console.log("button 2");
                        }) }, { children: "Button 2" })), (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => __awaiter(this, void 0, void 0, function* () {
                            yield handleGenerateToken();
                            console.log("button 3");
                        }) }, { children: "Button 3" }))] })] }));
}
exports.default = Test;
